import React, {Fragment} from "react";
import PropTypes from 'prop-types';

export default function FilterGroups({inputs}) {
 
  return (
    <Fragment>
      {inputs}
    </Fragment>
    )
};

FilterGroups.propTypes = {
  inputs: PropTypes.element.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/Common/FilterGroups.js